import { getSiteConfig } from '../utils/site';

export default function AppFooter() {
  const { appName } = getSiteConfig();
  return (
    <footer style={{
      textAlign: 'center',
      padding: '16px 12px',
      fontSize: 11,
      color: 'var(--text-muted)',
      opacity: 0.6,
    }}>
      {appName} v{__APP_VERSION__}
    </footer>
  );
}
